import { Link } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { formatPlainDateRange } from '../../i18n/travelFormat';

/**
 * 揪團日期衝突呈現（FORMOSA-GROUP-TRIP-DATE-CONFLICT）。
 * - blocked：本人已確認占用的揪團日期重疊，阻擋並列出自己的揪團。
 * - pending：申請已送出，但另有待審核申請日期重疊；只提醒，不是失敗。
 * - busy：日期檢查忙碌，可稍後重試（不自動重送）。
 * - applicant：主揪核准他人時，只說明無法核准，不顯示對方的其他行程。
 */
export default function GroupTripDateConflictNotice({ variant, trips = [], bodyKey }) {
  const { t, intlLocale } = useTravelTranslation();
  if (variant === 'busy' || variant === 'applicant') {
    const key = variant === 'busy' ? 'travel.groupTrip.dateConflict.busy' : 'travel.groupTrip.dateConflict.applicantConflict';
    return (
      <p className="group-trips__error" role="alert" data-testid={`group-trip-date-conflict-${variant}`}>
        {t(key)}
      </p>
    );
  }
  const pending = variant === 'pending';
  const titleKey = pending ? 'travel.groupTrip.dateConflict.pendingTitle' : 'travel.groupTrip.dateConflict.title';
  const textKey = bodyKey || (pending ? 'travel.groupTrip.dateConflict.pendingBody' : 'travel.groupTrip.dateConflict.body');
  return (
    <section
      className={`group-trips__date-conflict group-trips__date-conflict--${pending ? 'pending' : 'blocked'}`}
      role={pending ? 'status' : 'alert'}
      data-testid={`group-trip-date-conflict-${pending ? 'pending' : 'blocked'}`}
    >
      <p className="group-trips__date-conflict-title">{t(titleKey)}</p>
      <p className="group-trips__date-conflict-body">{t(textKey)}</p>
      {trips.length > 0 ? (
        <ul className="group-trips__date-conflict-list" aria-label={t('travel.groupTrip.dateConflict.tripListLabel')}>
          {trips.map((trip) => (
            <li key={trip.groupTripId}>
              <span>{formatPlainDateRange(trip.startDate, trip.endDate, intlLocale)}</span>
              <Link to={`/public/group-trips/${trip.groupTripId}`}>{t('travel.groupTrip.dateConflict.viewTrip')}</Link>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
